import { type ServiceConfig } from '../../ServiceRegistry';
import { AdminAuditLogService } from '@/services/admin/AdminAuditLogService';
import { AdminDomainService } from '@/services/admin/AdminDomainService';
import { AdminFeaturesService } from '@/services/admin/AdminFeaturesService';
import { AdminPermissionService } from '@/services/admin/AdminPermissionService';
import { AdminRolePermissionService } from '@/services/admin/AdminRolePermissionService';
import { AdminRoleService } from '@/services/admin/AdminRoleService';
import { AdminRoleTypeService } from '@/services/admin/AdminRoleTypeService';
import { AdminServiceCatalogService } from '@/services/admin/AdminServiceCatalogService';
import { AdminServiceCommunicationService } from '@/services/admin/AdminServiceCommunicationService';

/** Host-owned admin BFF services for federated aga-admin (same pattern as dealcard / titan). */
export const adminServices: ServiceConfig[] = [
  { name: 'adminAuditLogService', factory: () => new AdminAuditLogService() },
  { name: 'adminDomainService', factory: () => new AdminDomainService() },
  { name: 'adminFeaturesService', factory: () => new AdminFeaturesService() },
  { name: 'adminPermissionService', factory: () => new AdminPermissionService() },
  { name: 'adminRolePermissionService', factory: () => new AdminRolePermissionService() },
  { name: 'adminRoleService', factory: () => new AdminRoleService() },
  { name: 'adminRoleTypeService', factory: () => new AdminRoleTypeService() },
  { name: 'adminServiceCatalogService', factory: () => new AdminServiceCatalogService() },
  { name: 'adminServiceCommunicationService', factory: () => new AdminServiceCommunicationService() },
];

export const adminServiceUtils = {
  getServiceNames: () => adminServices.map(s => s.name),
  isAdminService: (name: string) => adminServices.some(s => s.name === name),
  getBasePath: () => '/admin',
};
